const InitialState = {
    useDarkMode: false,
};

export {
    InitialState,
}